export default __webpack_public_path__ + "static/medium-image-yangol-2-5b74228de6616fdf5d721546930b3202.png";